module.exports = __webpack_public_path__ + "static/media/profile.34465746.svg";